import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetDataButton({ onDone, periodo, vendedor }) {
  const [loading, setLoading] = useState(false);
  const single = vendedor && vendedor !== "__all__";

  const reset = async () => {
    setLoading(true);
    try {
      const params = {};
      if (periodo) params.periodo = periodo;
      if (single) params.vendedor = vendedor;
      const { data } = await api.post("/report/reset", null, { params });
      toast.success(data.message || "Datos del informe eliminados");
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudieron borrar los datos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button data-testid="reset-report-button" variant="outline" className="h-9 border-red-200 text-red-700 hover:bg-red-50">
          <Trash2 className="h-4 w-4 mr-1.5" /> Borrar datos
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Borrar datos del mes {periodo}?</AlertDialogTitle>
          <AlertDialogDescription>
            Se eliminarán las Cobranzas, Cuentas por Recibir y Pagarés del mes <strong>{periodo}</strong>
            {single ? <> únicamente del vendedor <strong>{vendedor}</strong></> : <> de todos tus vendedores visibles</>}.
            El histórico de los demás meses se conserva. Las visitas y garantías no se borran. Esta acción no se puede deshacer.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="reset-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction data-testid="reset-confirm" onClick={reset} disabled={loading} className="bg-red-600 hover:bg-red-700">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Sí, borrar {single ? "este vendedor" : "el mes"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
